export default "__VITE_ASSET__DQO8UyP$__"